jQuery('.faq-box').on('click', function() {
  jQuery(this).next().slideToggle();
  // alert('click');
  jQuery(this).children('.faq-box-icon').toggleClass('is-open');
});

jQuery('.icon--dot').on('click', function() {
  jQuery(this).next().slideToggle();
  // alert('click');
  jQuery(this).children('.icon--dot').toggleClass('is-open');
});

jQuery('a[href^="#"]').on('click', function() {

  var header = jQuery('.header').innerHight();
  var id = jQuery(this).attr('href');
  var position = jQuery(id).offset().top - header;
  //console.log(id);
  jQuery('html,body').animate({
    scrollTop: position
  },
  300);
});